import { END_POINTS } from "constants/APIConstant";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import ReactGA from "react-ga4";
import ContentLoading from "component/LoadingComponent/ContentLoading";
import InnerHeader from "component/shared/innerheader/InnerHeader";
// import MainButton from "component/shared/mainButton/MainButton";
import ResultComponent from "./components/ResultComponent";
import fetch from "auth/FetchInterceptor";

const Verification = () => {
  const { codeId, userId } = useParams();

  const [loading, setLoading] = useState(true);
  const [verified, setVerified] = useState(null);

  const navigate = useNavigate();

  const intl = useIntl();

  const sucessActions = [
    {
      label: intl.formatMessage({ id: "go-to-login" }),
      color: "primary",
      onClick: () => navigate("/login"),
    },
  ];

  const failActions = [
    {
      label: intl.formatMessage({ id: "go-to-home" }),
      color: "primary",
      onClick: () => navigate("/"),
    },
  ];

  useEffect(() => {
    var data = {
      Id: userId,
      Code: codeId,
    };
    fetch
      .post(END_POINTS.EMAIL_VERIFICATION, data)
      .then((response) => {
        if (response?.state) setVerified(true);
        else setVerified(false);
      })
      .finally(() => setLoading(false));
  }, []);

  ReactGA.initialize(END_POINTS.TRACKING_ID);

  React.useEffect(() => {
    // Send pageview with a custom path
    ReactGA.send({
      hitType: "pageview",
      page: "/verification/codeId/userId",
      title: "Verfication Page",
    });
  }, []);

  // const getServices = useSWR({
  //   url: `${END_POINTS.SERVICES_TOOLS}/${END_POINTS.NATIONAL_CENTER_ID}`,
  // });

  const Error = () => (
    <ResultComponent
      status="fail"
      title={intl.formatMessage({ id: "wrong-auth" })}
      //   subTitle="Your form has been submitted successfully."
      extra={failActions}
    />
  );

  const Success = () => (
    <ResultComponent
      status="success"
      title={intl.formatMessage({ id: "success-auth" })}
      //   subTitle="Your form has been submitted successfully."
      extra={sucessActions}
    />
  );

  return (
    <ContentLoading isLoading={false}>
      <div className="national-center">
        <InnerHeader
          breadcrumb={[
            {
              title: intl.formatMessage({ id: "account-verification" }),
              clickClass: true,
            },
          ]}
          title={intl.formatMessage({ id: "account-verification" })}
          // route={"../servicestools"}
        />

        <div className="container py-5">
          <div className="row">
            <div className="col-12">
              <ContentLoading isLoading={loading}>
                {verified && <Success />}
                {!verified && <Error />}
              </ContentLoading>
            </div>
          </div>
        </div>
      </div>
    </ContentLoading>
  );
};

export default Verification;
